export default "<p-menubar  [model]=\"items\"></p-menubar>\n\n\n\n<router-outlet></router-outlet>\n\n"